import API from '../../../API/api';
import {types as productTypes} from '../../../_constants/product/types';

function configuratorRequestTyre(selectedFilters, fieldsToLoad) {
    const filters = Object.assign({}, selectedFilters, { product_type: productTypes.TYRE_CAR });
    return API.POST({
        apiPath: '/configurator/home/',
        data: {
            filters,
            response: {fields: fieldsToLoad}
        },
        dataType: 'json'
    });
}

export default configuratorRequestTyre;